export const POINTS_TO_WIN_PRIZES = '3,000';
export const EXPECTED_QUESTIONS_NUM = 3;
export const RATE_VIDEO_POINTS = 500;